module.exports = __webpack_public_path__ + "fonts/Golos-Text_DemiBold.1b25197.woff";